import React from 'react';
import Hero from './components/Hero';
import Countdown from './components/Countdown';
import OurStory from './components/OurStory';
import PreWeddingEvents from './components/PreWeddingEvents';
import EventDetails from './components/EventDetails';
import SocialMedia from './components/SocialMedia';
import Gallery from './components/Gallery';
import RSVP from './components/RSVP';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Hero />
      <Countdown />
      <OurStory />
      <PreWeddingEvents />
      <EventDetails />
      <SocialMedia />
      <Gallery />
      <RSVP />
      <Footer />
    </div>
  );
}

export default App;
